<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols='12'>
        <!-- <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="successAction"/> -->
        <DataTableServer
          :datatable='table'
          :on-success='successAction'
          :itemsAction='successAction'
          :on-pagination="pagePagination"
          :on-search="getSearchPagePagination"
        />
      </v-col>
      <ViewDetailsMain :object="object" type="EquipoDetails" :actions="successAction" />
    </v-row>
    <MainFormDialog v-if="get_dialogMain.dialog" :model="objectMain" :params="paramsMain" :on-success="dataForm" />
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { UserSession } from '@/store/modules/config'
import { Permission } from '@/mixins/permissionMain'
import MainFormDialog from '@/components/dialog/main/MainFormDialog'
// import DataTableMain from '@/components/tables/DataTableMain'
import DataTableServer from '@/components/tables/DataTableMainServer'
import ViewDetailsMain from '@/components/details/ViewDetailsMain'

export default {
  mixins: [Permission],
  data: () => ({
    table: {
      modelMain: [],
      showSelect: true,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'inventario.create' }
        ],
        titles: [
          { text: 'Folio', value: 'folio', class: 'black--text' },
          { text: 'Procedencia', value: 'caracteristicas.procedencia.nombre', class: 'black--text' },
          { text: 'Departamento', value: 'departamento.nombre', class: 'black--text' },
          { text: 'Descripción', value: 'caracteristicas.descripcion', class: 'black--text' },
          { text: 'Marca', value: 'MarcaModelo', class: 'black--text' },
          { text: 'Serie', value: 'especificaciones.serie', class: 'black--text' },
          { text: 'Estatus', value: 'Status', class: 'black--text', align: 'center' },
          { text: '', value: 'Actions', align: 'right' }
        ],
        loading: false,
        filter: true,
        filterCount: 0
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar', icon: 'mdi-pencil', color: 'amber darken-2', action: 'updateData', code: '' }
        ]
      },
      footer: {
        paging: true
      }
    },
    filterTableData: {},
    pages: {},
    pagesDefault: {
      groupBy: [],
      groupDesc: [],
      itemsPerPage: 10,
      multiSort: false,
      mustSort: false,
      page: 1,
      params: {},
      sortBy: [],
      sortDesc: []
    },
    objectMain: {},
    paramsMain: {}
  }),
  components: {
    DataTableServer,
    ViewDetailsMain,
    MainFormDialog
  },
  mounted () {
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['getUrlServices', 'urlPostServicesActionPagination']),
    ...mapMutations(['SHOW_DIALOG_MAIN', 'SET_SERVICES']),
    // *==========*==========*==========* Methods Table Pagination *==========*==========*==========* \\
    pagePagination (val) {
      this.table.header.loading = true
      this.pages = val
      this.getDataUrl('inventario.equipos.show-pagination')
    },
    getSearchPagePagination (val) {
      this.table.header.loading = true
      this.pages = val
      this.getDataUrl('inventario.equipos.show-pagination')
      // this.getDataUrl('ma.list-pagination-search')
      // this.pages = val
    },
    getDataUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.urlPostServicesActionPagination({ url: router })
      } else {
        this.getUrlServices()
      }
    },
    filterData (item) {
      this.objectMain = this.filterTableData
      this.paramsMain = {
        form: this.get_InventariosEquiposFilterForm,
        message: 'Registro Agregado Correctamente',
        returnObject: true,
        setmodel: true
      }
      this.SHOW_DIALOG_MAIN({ type: 'filter', with: '60%', title: 'FILTRAR' })
    },
    dataForm ({ name, model }) {
      if (name === 'filter') {
        this.filterTableData = model
        let count = 0
        this.get_MesaAyudaFilterForm.map(field => {
          if (model[field.nameid]) count += 1
        })
        this.table.header.filterCount = count
        this.table.header.loading = true
        if (this.pages) {
          if (this.pages.search) {
            this.pages.params = model
            this.getDataUrl('inventario.equipos.show-pagination')
          } else {
            this.pages = this.pagesDefault
            this.pages.params = model
            this.getDataUrl('inventario.equipos.show-pagination')
          }
        } else {
          this.pages = this.pagesDefault
          this.pages.params = model
          this.getDataUrl('inventario.equipos.show-pagination')
        }
      } else {
        this.getDataUrl('inventario.equipos.show-pagination')
      }
    },
    // ==========*==========*==========*==========*==========*==========*==========*==========* \\
    // ==========*==========*==========*==========*==========*==========*==========*==========* \\
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.pages = item.pagination
      this.getDataUrl('inventario.equipos.show-pagination')
    },
    newData (item) {
      this.objectMain = { tipo_inventario_id: 1, departamento_id: UserSession().departamento_id }
      this.paramsMain = {
        urloption: this.get_urls['inventario.options'],
        url: this.get_urls['inventario.execute'],
        process: 1,
        actividad: 1,
        message: 'Registro Agregado Correctamente',
        showFamilia: true,
        familiaParams: '?insumo=0',
        setmodel: true,
        returnObject: true
      }
      this.SHOW_DIALOG_MAIN({ type: 'create', form: 'process', with: '60%', title: 'Nuevo Equipo' })
    },
    updateData ({ item }) {
      item.caracteristicas.departamento_id = item.departamento_id
      this.objectMain = item
      this.paramsMain = {
        urloption: this.get_urls['inventario.options'],
        url: this.get_urls['inventario.execute'],
        process: 1,
        actividad: 1,
        message: 'Registro Agregado Correctamente',
        showFamilia: true,
        familiaParams: '?insumo=0',
        setmodel: true,
        updated: true
      }
      this.SHOW_DIALOG_MAIN({ type: 'update', form: 'process', with: '60%', title: 'Editar Equipo' })
    },
    toAssign (item) {
      this.objectMain = item
      this.paramsMain = {
        urloption: this.get_urls['inventario.options'],
        url: this.get_urls['inventario.execute'],
        process: 1,
        message: 'Registro Agregado Correctamente'
      }
      this.SHOW_DIALOG_MAIN({ type: 'assign', form: 'process', with: 600, title: 'Asignar Equipo' })
    },
    toStock (item) {
      this.objectMain = item
      this.paramsMain = {
        urloption: this.get_urls['inventario.options'],
        url: this.get_urls['inventario.execute'],
        process: 1,
        message: 'Registro Agregado Correctamente'
      }
      this.SHOW_DIALOG_MAIN({ type: 'stock', form: 'process', with: 500, title: 'Resguardar Equipo' })
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_objectPagination', 'get_InventariosEquiposFilterForm']),
    object () {
      if (this.table.modelMain.length > 0) {
        return this.table.modelMain[0]
      }
      return {}
    }
  },
  watch: {
    get_urls (val) {
      if (val) {
        this.getDataUrl('inventario.equipos.show-pagination')
      }
    },
    get_objectPagination (val) {
      if (val) {
        this.table.body.data = val.data
        this.table.body.totalData = val.total
        if (val.data.length > 0) {
          this.table.modelMain = []
          this.table.modelMain.push(val.data[0])
        } else {
          this.table.modelMain = []
        }
        this.table.header.loading = false
      }
    }
  }
}
</script>

<style>
</style>
